import BaseService from "./BaseService";

class SelfService {
  static async profile() {
    return await BaseService.callAPI("/self/profile");
  }

  static async learningPrograms() {
    return await BaseService.callAPI("/self/pathways");
  }

  static async changePassword(data) {
    return await BaseService.callAPI(`/self/change-password`, "POST", data);
  }

  static async setPassword(data) {
    return await BaseService.callAPI(`/self/set-password`, "POST", data);
  }

  static async compliancePassport() {
    return await BaseService.callAPI("/self/pathways/completed");
  }

  static async programDetails({ id }) {
    return await BaseService.callAPI(`/self/pathways/${id}`);
  }

  static async markAsCompleted({ id }) {
    return await BaseService.callAPI(`/self/object/${id}/complete`, "POST");
  }

  static async learningStats() {
    return await BaseService.callAPI("/self/learning/stats");
  }

  static async learningStatusCount() {
    return await BaseService.callAPI("/self/learning/status/count");
  }

  static async notifications() {
    return await BaseService.callAPI("/self/notifications");
  }

  static async fullProfile() {
    return await BaseService.callAPI("/self/full-profile");
  }

  static async updateAccountPreferences(data) {
    return await BaseService.callAPI(`/self/account/preferences`, "POST", data);
  }

  static async update({ id, detailType, ...data }) {
    let url = ``;
    if (detailType === "personal_details") {
      url = `/self/personal-details`;
    } else if (detailType === "official_details") {
      url = `/self/official-details`;
    } else if (detailType === "dynamic_details") {
      url = `/self/dynamic-details`;
    }
    return await BaseService.callAPI(url, "PUT", data);
  }

  /** My Team Reports */
  static async learningObjectCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-objects/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-objects/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-objects/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-objects/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningMilestonesUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-milestones/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningProgramsUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-programs/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningProgramCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-programs/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningProgramsSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-programs/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningProgramsUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-programs/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestoneCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-milestones/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestonesSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-milestones/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestonesUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `self/learning-milestones/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async markNotificationAsRead({ id }) {
    return await BaseService.callAPI(
      `/self/notifications/${id || "all"}/read`,
      "POST"
    );
  }

  static async selfRewards() {
    return await BaseService.callAPI("/self/rewards");
  }

  static async pointsHistory() {
    return await BaseService.callAPI("/self/points/history");
  }
}

export default SelfService;
